module.exports = __webpack_public_path__ + "static/media/shiv.6045f81a.webp";